import BonusCommonPage from './BonusCommonPage';

export default BonusCommonPage;
